import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import AuthInfoPage, { ButtonContainer, Message } from 'components/AuthInfoPage';
import CustomButton from 'components/Button';
import { ROUTES } from '../../constants';

export default function AccountAlreadyActive() {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <AuthInfoPage title={t('auth.accountAlreadyActive.title')}>
      <Message variant="body2">{t('auth.accountAlreadyActive.message')}</Message>
      <ButtonContainer>
        <CustomButton onClick={() => history.push(ROUTES.LOGIN)}>
          {t('auth.accountAlreadyActive.button')}
        </CustomButton>
      </ButtonContainer>
    </AuthInfoPage>
  );
}
